import { useTranslation } from "features/translations";
import React, { useMemo } from "react";
import { Container, Heading3, PageLink, Paragraph } from "shared/components";

import { Item } from "../Item";
import styles from "./GridView.module.scss";

export const GridView = ({
  title,
  description,
  contentType,
  events,
  articles,
}) => {
  const { t } = useTranslation();

  const limitedItem = useMemo(
    () => (contentType === "event" ? events.slice(0, 3) : articles.slice(0, 3)),
    [articles, contentType, events]
  );

  return (
    <>
      <Container className={styles.inner}>
        <div className={styles.header}>
          <Heading3 className={styles.title}>{title}</Heading3>
          <Paragraph className={styles.description} color="dark">
            {description}
          </Paragraph>
        </div>
        {limitedItem.map((item) => (
          <Item
            key={item.id}
            className={styles.item}
            {...item}
            contentType={contentType}
          />
        ))}
        <PageLink
          slug={contentType === "article" ? "news" : "events"}
          className={styles.link}
        >
          <Paragraph className={styles.text} color="dark" uppercase>
            {contentType === "article" ? t("showAllNews") : t("showAllEvents")}
          </Paragraph>
        </PageLink>
      </Container>
    </>
  );
};

export default GridView;
